import { InterpretedData } from './interpreted-data.model';

export class RunningState
{
    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            this.DataTimeStamp = new Date(json.DataTimeStamp);
        }
    }

    public Alarms: any;
    public Aux2Schedule: any;
    public Aux3Schedule: any;
    public AuxiliaryStates: any[];
    public DataTimeStamp: Date;
    public InterpretedData: InterpretedData;
    public ManualSchedule: any;
    public MasterValveStatus: any;
    public ScheduleStates: any[];
    public StationStatusList: any[];
}
